export class PortalLogger {
    constructor(element) {
        const { portalLoggerEvent, portalLoggerPayload, portalLoggerAction } = element.dataset;

        let action = 'click';

        if (portalLoggerAction) {
            action = portalLoggerAction;
        }
        
        this.event = portalLoggerEvent;
        this.payload = JSON.parse(portalLoggerPayload);

        element.addEventListener(action, () => {
            this.log();
        });
    }

    async log() {
        await fetch(route('portal-logger.log'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]').getAttribute('content')
            },
            body: JSON.stringify({
                event: this.event,
                timestamp: Date.now(),
                payload: this.payload,
                _token: document.querySelector('meta[name=csrf-token]').getAttribute('content')
            })
        });
    };
}